export default __webpack_public_path__ + "ee46bc77555c135551135eef89b74da7.svg";